import { colorsDark } from "assets/themeDark/colorUtil";
import { TypesColor } from "types/theme";

const colors: TypesColor = colorsDark;

export default colors;
